import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { CenteredFlexBox, FullSizeColumn } from '../../../../Components/FlexBox';
import { formatThousands } from '../../../../Utils/constants/general';
import useTranslate from '../../../../Hooks/useTranslate';

export const CALL_DETAILS_GRID =
  'minmax(0, 1.4fr) auto minmax(0, 1fr) minmax(0, 1fr)';

export const CALL_DETAILS_COLUMN_GAP = { xs: '8px', lg: '12px', xl: '16px' };

export const callDetailsValueSx = {
  color: '#607d8b',
  textAlign: 'right',
  fontWeight: 500,
  fontSize: { xs: '1.1rem', lg: '1.35rem', xl: '1.5rem' },
  whiteSpace: 'nowrap',
};

const ColumnValue = function ColumnValue({ value }) {
  return (
    <Typography sx={callDetailsValueSx}>{formatThousands(value)}</Typography>
  );
};

const SectionCallDetailsPaper = function SectionCallDetailsPaper({
  rows = [],
  onClick,
  selected,
}) {
  const translate = useTranslate();

  return (
    <Paper
      sx={{
        padding: '20px',
        cursor: onClick ? 'pointer' : 'default',
        outline: selected
          ? (theme) => `2px solid ${theme.palette.primary.main}`
          : 'none',
      }}
      onClick={onClick}
    >
      <FullSizeColumn>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: CALL_DETAILS_GRID,
            alignItems: 'center',
            columnGap: CALL_DETAILS_COLUMN_GAP,
            rowGap: '20px',
          }}
        >
          <Box />
          <Box />
          <Typography
            variant="body2"
            sx={{ color: '#90a4ae', textAlign: 'right' }}
          >
            {translate('TOTAL_CALLS')}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: '#90a4ae', textAlign: 'right' }}
          >
            {translate('UNIQUE_CONTACTS')}
          </Typography>

          {rows.map(({ icon, label, total, unique }, index) => (
            <React.Fragment key={index}>
              <CenteredFlexBox gap="16px" minWidth={0}>
                {icon}
                <Typography
                  variant="body1"
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {label}
                </Typography>
              </CenteredFlexBox>
              <Typography
                sx={{
                  textAlign: 'right',
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  fontSize: { xs: '1.1rem', lg: '1.35rem', xl: '1.5rem' },
                  color: (theme) => theme.palette.primary.main,
                }}
              >
                {unique.percentage != null ? `${unique.percentage}%` : ''}
              </Typography>
              <ColumnValue value={total} />
              <ColumnValue value={unique.value} />
            </React.Fragment>
          ))}
        </Box>
      </FullSizeColumn>
    </Paper>
  );
};

export default SectionCallDetailsPaper;
